/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AllegatoDTO { 
    id?: string;
    origine?: string;
    tipo_file_sistema?: string;
    chiave_attributo?: string;
    nome_file_originale?: string;
    content_type?: string;
    size_bytes?: number;
    uploaded_at?: string;
}

